import { Slider } from '../ui/slider';
import { Switch } from '../ui/switch';
import { bus } from '../../lib/bus';

const SFX = ['jump', 'laser', 'explosion', 'powerup', 'coin', 'hit', 'gameover'];

function Row({ label, value, fmt, ...p }) {
  return (
    <div className="space-y-2.5">
      <div className="flex justify-between text-xs"><span className="text-slate-300">{label}</span><span className="font-bold text-cyan-300 tabular-nums">{fmt(value)}</span></div>
      <Slider value={[value]} {...p} />
    </div>
  );
}

export default function AudioPanel({ settings, updateSettings }) {
  const pct = (v) => `${Math.round(v * 100)}%`;
  return (
    <div data-testid="audio-panel" className="space-y-6">
      <div className="t-label">Universal Procedural Synth</div>
      <Row data-testid="vol-master" label="Master" value={settings.master} fmt={pct} min={0} max={1} step={0.01} onValueChange={([v]) => updateSettings({ master: v })} />
      <Row data-testid="vol-sfx" label="SFX" value={settings.sfx} fmt={pct} min={0} max={1} step={0.01} onValueChange={([v]) => updateSettings({ sfx: v })} />
      <Row data-testid="vol-music" label="Musica" value={settings.music} fmt={pct} min={0} max={1} step={0.01} onValueChange={([v]) => updateSettings({ music: v })} />
      <div className="rounded-xl border border-violet-500/20 p-3 space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-xs text-slate-300">Arpeggiatore Chiptune</span>
          <Switch data-testid="music-toggle" checked={settings.musicOn} onCheckedChange={(v) => updateSettings({ musicOn: v })} />
        </div>
        <Row data-testid="music-bpm" label="BPM" value={settings.bpm} fmt={(v) => v} min={60} max={200} step={1} onValueChange={([v]) => updateSettings({ bpm: v })} />
      </div>
      <div>
        <div className="t-label mb-2">Test SFX</div>
        <div className="grid grid-cols-4 gap-1.5">
          {SFX.map((s) => (
            <button key={s} data-testid={`sfx-${s}`} onClick={() => bus.post({ type: 'sfx', name: s })}
              className="rounded-lg border border-cyan-500/25 py-2 text-[10px] uppercase tracking-wider text-cyan-200 hover:bg-cyan-500/10 active:scale-95 transition-[transform,background-color]">{s}</button>
          ))}
        </div>
        <p className="mt-2 text-[10px] text-slate-500 t-chat">Oscillatori Web Audio · zero file esterni. Tocca prima il gioco per sbloccare l'audio.</p>
      </div>
    </div>
  );
}
